import { render } from "./ownerVisitors.vue?vue&type=template&id=e04a8adc&scoped=true&ts=true"
import script from "./ownerVisitors.vue?vue&type=script&lang=ts"
export * from "./ownerVisitors.vue?vue&type=script&lang=ts"

import "./ownerVisitors.vue?vue&type=style&index=0&id=e04a8adc&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e04a8adc"]])

export default __exports__